import React, { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import HeaderRoutes from "../HeaderRoutes/HeaderRoutes";
import { containsPartFromArray } from "../../functions/helper";

export default function ManagementHeaderNav({ small }) {
    const { permission, pages, pagesName } = useContext(AuthContext);
    const [step, setStep] = useState();
    const headerLinks = [
        {
            label: "Schedule",
            link: "/firehouse/schedule",
            hide: !pages.includes("SCHEDULE"),
        },
        {
            label: "Calendar",
            link: "/firehouse/calendar",
        },
        {
            label: "My Shifts",
            link: "/firehouse/my-shifts",
        },
        {
            label: "My Team",
            link: "/firehouse/my-team",
            // hide : !pages.includes('myTeam')
        },
        // {
        //     label: "Callbacks",
        //     link: "/firehouse/callbacks",
        //     hide: !permission.includes("CB_Auth"),
				//		 hide: (!containsPartFromArray(permission, "CB_Auth"))
        // },
        {
            label: Object.keys(pagesName).includes("MENU_TEXT_FILL_SHIFTS") ? pagesName.MENU_TEXT_FILL_SHIFTS : "Fill Shifts",
            link: "/firehouse/fill-shift",
            hide: (pages.includes("V3_NEW_FILL_STRUCTURE") || !containsPartFromArray(permission, "OT_Auth") || pages.includes("V3_POSITION_ASSIGNMENT_FILLABLE")),
        },
        {
            label: "Fill Positions",
            link: "/firehouse/fill-positions",
            hide: (!pages.includes("V3_POSITION_ASSIGNMENT_FILLABLE") || !containsPartFromArray(permission, "OT_Auth")),
        },
        {
            label: "Shift Calls",
            link: "/firehouse/shift-calls",
            hide: (!pages.includes("V3_NEW_FILL_STRUCTURE") || !containsPartFromArray(permission, "OT_Auth")),
        },
        {
            label: "My Shift Calls",
            link: "/firehouse/my-shift-calls",
            hide: (!pages.includes("V3_NEW_FILL_STRUCTURE")),
        },
        {
            label: "Batch Splitting",
            link: "/firehouse/batchSplitting",
            hide: !pages.includes("MENU_BATCH_SPLITTING"),
        },
        {
            label: "Details",
            link: "/firehouse/details",
            hide: !permission.includes("Schedule_Auth"),
        },
        {
            label: "Accept Shifts",
            link: "/firehouse/accept-shifts",
        },
        // {
        //     label: "Messaging",
        //     link: "/firehouse/messaging",
        //     hide: !permission.includes("SMS_Auth"),
        // },
        // {
        //     label: Object.keys(pagesName).includes("MENU_TEXT_LISTS") ? pagesName.MENU_TEXT_LISTS : "Lists",
        //     link: "/firehouse/lists",
        //     hide: !pages.includes("MENU_LISTS"),
        // },
        {
            label: "Approve RTO",
            link: "/firehouse/approve-shifts",
            hide: !containsPartFromArray(permission, "OT_Auth,OT_APPROVE"),
        },
        {
            label: "Members",
            link: "/firehouse/members",
            hide: !permission.includes("OT_Auth"),
        },
        {
            label: "List",
            link: "/firehouse/Lists",
        },
        {
            label: "RTO",
            link: "/firehouse/RTO",
        },
    ];
    useEffect(() => {
        let i = headerLinks.findIndex((x) => {
            return x.link == window.location.pathname;
        });
        setStep(i);
        if (document.querySelector("[href='/firehouse/calendar']")) {
            document
                .querySelector("[href='/firehouse/calendar']")
                .classList.add("RaMenuItemLink-active");
        }
        return () => {
            if (document.querySelector("[href='/firehouse/calendar']")) {
                document
                    .querySelector("[href='/firehouse/calendar']")
                    .classList.remove("RaMenuItemLink-active");
            }
        };
    }, []);

    return (
        <>
            <div className={`${small ? "small-navigator" : ""} "d-flex`}>
                {step != undefined &&
                    <HeaderRoutes step={step} steps={headerLinks} />
                }
                <div style={{ width: "5px" }}></div>
            </div>
        </>
    );
}
